var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"C-headline-author-wrapper"},[(_vm.authorNames)?_c('span',{staticClass:"C-headline-author"},[_vm._v(_vm._s(_vm.authorNames))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }